export default __webpack_public_path__ + "assets/front/scss/user-authentication.24516280593a0c3aca5446b2aec937bc.css";